import { createAction } from './utils';

export const SET_CURRENT_NAVIGATION_SECTION = 'SET_CURRENT_NAVIGATION_SECTION';
export const setCurrentNavigationSectionAction = (sectionId: string | undefined) =>
  createAction(SET_CURRENT_NAVIGATION_SECTION, sectionId);
